<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import { ChevronUp } from 'lucide-vue-next';

const THRESHOLD = 400;
const visible = ref(false);

function onScroll() {
  visible.value = window.scrollY > THRESHOLD;
}

function scrollTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

onMounted(() => {
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
});

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll);
});
</script>

<template>
  <button
    type="button"
    aria-label="Tillbaka till toppen"
    class="fixed bottom-6 left-6 z-40 flex h-10 w-10 items-center justify-center rounded-full border border-border bg-background p-0 text-foreground shadow-md transition-all duration-300 hover:bg-accent"
    :class="visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'"
    @click="scrollTop"
  >
    <ChevronUp class="h-5 w-5" />
  </button>
</template>
